import {MESSAGE_CATEGORY} from '../../../../CodeMaster';

export function getMessageCategoryColor(categoryId: string): string {
    switch (categoryId) {
        case MESSAGE_CATEGORY.OPERATING_COMPANY.value:
            return `#5aabce`;
        case MESSAGE_CATEGORY.MANAGEMENT_COMPANY.value:
            return `#6b83de`;
        case MESSAGE_CATEGORY.ASSOC.value:
            return `#ff6378`;
        case MESSAGE_CATEGORY.CLUB.value:
            return `#a7d155`;
        case MESSAGE_CATEGORY.CIRCLE.value:
            return `#4eba78`;
        case MESSAGE_CATEGORY.COMMITTEE.value:
            return `#fe8b2f`;
        case MESSAGE_CATEGORY.MANAGEMENT_COMPANY_PR.value:
            return `#a975d5`;
        case MESSAGE_CATEGORY.RESIDENTS_ASSOCIATION.value:
            return `#ffbc48`;
        default:
            return `#8457a9`;
    }
}
